import { DetailedUser, OverrideComparator } from '@mews-commander/data-access';
import { FieldNames } from './components/FieldNames';

export interface LockedFormProps {
    lockedFields: Partial<{ [key in FieldNames]: boolean }>;
    setLockedFields: (field: Partial<{ [key in FieldNames]: boolean }>) => void;
    fieldsConfig: (keyof OverrideComparator)[];
    detailedUser?: DetailedUser;
    isUserProvisioned?: boolean;
}

export const MULTIPLE_VALUES = 'multiple';

export enum RolesAndPermissionsOption {
    Admin = 'admin',
    Roles = 'roles',
    CustomizedPermissions = 'customizedPermissions',
    NoPermissions = 'noPermissions',
}

// TODO: bring this down to 2 - property and central
export enum UserType {
    Portfolio = 'portfolio',
    Properties = 'properties',
    Local = 'local',
}

export enum EnterpriseType {
    Portfolio = 'portfolio',
    Property = 'property',
}
